import { Field, ID, InputType, ObjectType, registerEnumType } from 'type-graphql'
import { DocumentAssetTypeEnum } from './DocumentAssetTypeEnum'

// Registered beside the fields that use them so the enum files stay decorator-free for the mobile apps.
registerEnumType(DocumentAssetTypeEnum, {
  name: 'DocumentAssetTypeEnum',
  description: 'Document types that support cross-domain asset attachment',
})

@ObjectType()
@InputType('MatchedDocumentInput')
export class MatchedDocument {
  @Field(() => String)
  documentCode: string

  @Field(() => DocumentAssetTypeEnum, { nullable: true })
  documentType: DocumentAssetTypeEnum | null

  @Field(() => Boolean)
  exists: boolean

  @Field(() => ID, { nullable: true })
  documentId?: string
}
